export default "/institutions/brand-elo.svg";